import React from "react";
import { VISION, ASSETS } from "@/data/content";
import { Reveal } from "@/lib/reveal";

export const Vision = () => (
 <section id="vision" data-testid="vision" className="relative overflow-hidden bg-cream py-24 md:py-32">
 <div className="mx-auto max-w-[1400px] px-5 md:px-10">
 <div className="grid items-stretch gap-12 lg:grid-cols-12 lg:gap-16">
 {/* Image column, quote integrated over the photograph */}
 <Reveal className="lg:col-span-5">
 <div className="relative h-full">
 <div className="relative overflow-hidden rounded-2xl shadow-[0_24px_60px_rgba(42,32,21,0.22)]">
 <img
 src={ASSETS.mikeTeach}
 alt="A Carbon8 farmer reading the soil at a field day"
 className="h-[520px] w-full object-cover object-center md:h-[640px]"
 />
 <div className="absolute inset-0 bg-gradient-to-b from-ink/85 via-ink/10 to-ink/30" />
 <blockquote className="absolute inset-x-0 top-0 p-7 md:p-9">
 <p className="font-display text-2xl font-medium leading-[1.15] text-cream md:text-[2rem]">
 <span className="text-ochre">“</span>{VISION.pull}<span className="text-ochre">”</span>
 </p>
 </blockquote>
 </div>
 {/* Watercolour peeking at the seam */}
 <img
 src={ASSETS.wcWalking}
 alt=""
 aria-hidden
 className="pointer-events-none absolute -bottom-12 -left-16 hidden h-80 w-auto object-contain drop-shadow-[0_20px_28px_rgba(42,32,21,0.22)] lg:block lg:h-[30rem]"
 />
 </div>
 </Reveal>

 {/* Text column, numbered, flowing, not boxed */}
 <div className="lg:col-span-7 lg:pl-6">
 <Reveal>
 <span className="font-body text-xs uppercase tracking-[0.3em] text-ochre">{VISION.kicker}</span>
 <h2 className="mt-4 font-display text-4xl font-medium leading-[1.02] text-ink sm:text-5xl">
 Regeneration on the land, and coherence in the story.
 </h2>
 </Reveal>

 <div className="mt-10 space-y-9">
 {VISION.chapters.map((c, idx) => (
 <Reveal key={c.n} delay={idx * 0.08}>
 <div className="grid grid-cols-[auto_1fr] items-start gap-5 border-t border-clay pt-6">
 <span className="font-display text-4xl font-light leading-none text-ochre/80 md:text-5xl">{c.n}</span>
 <div>
 <h3 className="font-display text-xl font-medium text-forest md:text-2xl">{c.title}</h3>
 <p className="mt-2 font-body text-base leading-relaxed text-ink/75">{c.body}</p>
 </div>
 </div>
 </Reveal>
 ))}
 </div>
 <Reveal delay={0.1}>
 <p className="mt-8 font-script text-2xl text-sage">What we plant in narrative, we harvest in movement.</p>
 </Reveal>
 </div>
 </div>
 </div>
 </section>
);
